import { render } from "./GroupDetail.vue?vue&type=template&id=4f689a0a&scoped=true&ts=true"
import script from "./GroupDetail.vue?vue&type=script&lang=ts"
export * from "./GroupDetail.vue?vue&type=script&lang=ts"

import "./GroupDetail.vue?vue&type=style&index=0&id=4f689a0a&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f689a0a"]])

export default __exports__